import { render, staticRenderFns } from "./MemoTagEditDialog.vue?vue&type=template&id=33ce7672&scoped=true"
import script from "./MemoTagEditDialog.vue?vue&type=script&lang=ts"
export * from "./MemoTagEditDialog.vue?vue&type=script&lang=ts"
import style0 from "./MemoTagEditDialog.vue?vue&type=style&index=0&id=33ce7672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ce7672",
  null
  
)

export default component.exports